<template>
    <div>
        <!-- :label="field.label" -->
        <b-form-group
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired || isRequired,
            }"
        >
            <label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ fieldLabel }}</label
            >
            <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine" /><span
                    v-if="field.urduLabel"
                    class="urdu-label"
                    >({{ field.urduLabel }})</span
                ></label
            > -->
            <b-form-select
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                type="text"
                autocomplete="no"
                :placeholder="field.placeholder"
                :disabled="loading || isDisabled || field.isDisabled"
                :options="options"
                :text-field="textField"
                :value-field="valueField"
                :data-vv-name="field.label"
                class="form-control custom-select"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
                @blur="handleBlur"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
import request from '@/utils/request'
import axios from 'axios'
import _ from 'lodash'
const apiUrl_data = process.env.VUE_APP_API_URL
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
        textField: {
            type: String,
            default: 'text',
        },
        valueField: {
            type: String,
            default: 'value',
        },
        isRequired: {
            type: Boolean,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            value: null,
            options: [],
            isDisabled: false,
            cities: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),
        dataSegmentId() {
            if (this.$store.getters.dataSegmentId) {
                //    console.log("getters in dropdown", this.$store.getters.dataSegmentId)
                return this.$store.getters.dataSegmentId
            } else {
                // console.log("env in dropdown")
                return process.env.VUE_APP_SSA_ACCOUNT
            }
        },
        urduLabel() {
            if (this.$store.state.registration.form.languageOption == 'urd') {
                return true
            } else {
                return false
            }
        },
        fieldLabel() {
            if (
                ['Country of Residence', 'Country of Tax Residence'].includes(
                    this.field.label
                )
            ) {
                return this.field.label + ' (As per your identity card)'
            }
            return this.field.label
        },

        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        if (this.field.key == 'basicInfo.zakatId') {
            if (
                this.$store.state.registration.form.basicInfo.religion ==
                'Muslim'
            ) {
                this.field.isRequired = true
                this.field.isDisabled = false
            } else {
                this.field.isDisabled = true
                this.field.isRequired = false
            }
        }

        if (this.field.key == 'accountInfo.operateAccount') {
            let newValue = 'Only the Principal Account Holder'
            this.writeValue(newValue)
            this.isDisabled = true
        }

        // update the options field from props
        this.options = this.field.options

        // initialize if custom field
        if (!this.field.isLocked) {
            this.$store.commit('initCustomField', {
                key: `${this.field._id}`,
                value: {
                    title: this.field.label,
                    type: this.field.type,
                    value: null,
                },
            })
        }

        if (this.field.key == 'basicInfo.gender') {
            this.field.isDisabled = true
        }
        if (this.field.key == 'contactInfo.cityId') {
            if (
                this.$store.state.registration.form.contactInfo.state ==
                '* Non-Pakistan (if not Resident in Pakistan)'
            ) {
                this.field.isRequired = false
                this.field.isDisabled = true
            } else {
                this.field.isDisabled = false
                this.field.isRequired = true
            }
        }
        // if (this.field.key == 'fatcaInfo.dualNationalCountry') {
        //     if (
        //         this.$store.state.registration.form.fatcaInfo.dualNational ==
        //         'Yes'
        //     ) {
        //         this.field.isRequired = true
        //         this.field.isDisabled = false
        //     } else {
        //         this.value = null
        //         this.model = null
        //         this.writeValue(null)
        //         this.field.isDisabled = true
        //         this.field.isRequired = false
        //     }
        // }
        if (this.field.key == 'fatcaInfo.CountryResident') {
            if (
                this.$store.state.registration.form.fatcaInfo
                    .CountryResidentOption == 'Yes'
            ) {
                // console.log(newValue)
                this.field.isDisabled = false
                this.field.isRequired = true
            } else {
                this.writeValue(null)
                this.field.isDisabled = true
                this.field.isRequired = false
            }
        }
        if (this.field.key == 'fatcaInfo.CountryTax') {
            if (
                this.$store.state.registration.form.fatcaInfo
                    .CountryTaxOption == 'Yes'
            ) {
                this.field.isDisabled = false
                this.field.isRequired = true
            } else {
                this.writeValue(null)
                this.field.isDisabled = true
                this.field.isRequired = false
            }
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> country of tax 1
        // if (this.field.key == 'crsInfo.crsReason1') {

        //     if (
        //         this.$store.state.registration.form.crsInfo.crsCountryTax1 &&
        //         this.$store.state.registration.form.crsInfo.crsCountryTax1
        //             .length
        //     ) {
        //         this.isDisabled = false
        //         this.field.isRequired = true
        //     } else {
        //         // this.isDisabled  = false
        //         this.field.isRequired = false
        //     }
        // } // End

        // // Watching CRS Form for Tax Residency Self Certification -> country of tax 2
        // if (this.field.key == 'crsInfo.crsReason2') {

        //     if (
        //         this.$store.state.registration.form.crsInfo.crsCountryTax2 &&
        //         this.$store.state.registration.form.crsInfo.crsCountryTax2
        //             .length
        //     ) {

        //         this.isDisabled = false
        //         this.field.isRequired = true
        //     } else {
        //         // this.isDisabled  = false
        //         this.field.isRequired = false
        //     }
        // } // End

        // // Watching CRS Form for Tax Residency Self Certification -> country of tax 3
        // if (this.field.key == 'crsInfo.crsReason3') {

        //     if (
        //         this.$store.state.registration.form.crsInfo.crsCountryTax3 &&
        //         this.$store.state.registration.form.crsInfo.crsCountryTax3
        //             .length
        //     ) {

        //         this.isDisabled = false
        //         this.field.isRequired = true
        //     } else {
        //         // this.isDisabled  = false
        //         this.field.isRequired = false
        //     }
        // } // End

        // Watching CRS Form for Tax Residency Self Certification -> TIN 1
        if (this.field.key == 'crsInfo.crsReason1') {
            if (
                this.$store.state.registration.form.crsInfo.crsTIN1 &&
                this.$store.state.registration.form.crsInfo.crsTIN1.length 
                &&  this.$store.state.registration.form.crsInfo.crsReason1 =='none'
                            
            ) {
                this.field.isRequired = false
                // this.isDisabled = true
                this.field.isDisabled = true
                this.writeValue(null)
            } else {
                this.field.isDisabled = false
                // this.field.isRequired = true
            }
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> TIN 2
        if (this.field.key == 'crsInfo.crsReason2') {
            // console.log('TIN 2 number ')
            if (
                this.$store.state.registration.form.crsInfo.crsTIN2 &&
                this.$store.state.registration.form.crsInfo.crsTIN2.length
            ) {
                this.field.isDisabled = true
                this.field.isRequired = false
                this.writeValue(null)
            } else {
                this.field.isDisabled = false
                // this.field.isRequired = true
            }
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> TIN 3
        if (this.field.key == 'crsInfo.crsReason3') {
            if (
                this.$store.state.registration.form.crsInfo.crsTIN3 &&
                this.$store.state.registration.form.crsInfo.crsTIN3.length
            ) {
                this.field.isDisabled = true
                this.field.isRequired = false
                this.writeValue(null)
            } else {
                this.field.isDisabled = false
                // this.field.isRequired = true
            }
        } // End
    }, // End of Component > mounted

    created() {
        // IF COUNTRY OF RESIDENCE OTHER THAN PAKISTAN
        if (this.field.key == 'fatcaInfo.CountryResident') {
            this.field.isDisabled = true
            this.field.isRequired = false
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.fatcaInfo
                        .CountryResidentOption
                },
                (newValue) => {
                    // console.log('Key is fatcaInfo.CountryTax ')
                    if (newValue == 'Yes') {
                        // console.log(newValue)
                        this.field.isDisabled = false
                        this.field.isRequired = true
                    } else {
                         this.$store.commit('updateField', {
                            key: 'fatcaInfo.CountryResidentTitle',
                            value: null,
                        })
                        this.value = null
                        this.model = null
                        this.writeValue(null)
                        this.field.isDisabled = true
                        this.field.isRequired = false
                    }
                }
            )
        } // End
        //IF DUAL NATIONALITY IS YES
        if (this.field.key == 'fatcaInfo.dualNationalCountry') {
            this.field.isDisabled = true
            this.field.isRequired = false
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.fatcaInfo
                        .dualNational
                },
                (newValue) => {
                    //console.log('Key is fatcaInfo.CountryTax ')
                    if (newValue == 'Yes') {
                        // console.log(newValue)
                        this.field.isDisabled = false
                        this.field.isRequired = true
                    } else {
                        this.$store.commit('updateField', {
                            key: 'fatcaInfo.dualNationalCountryTitle',
                            value: null,
                        })
                        this.value = null
                        this.model = null
                        this.writeValue(null)
                        this.field.isDisabled = true
                        this.field.isRequired = false
                    }
                },
                { immediate: true }
            )
        } // End
        

        if (this.field.key == 'contactInfo.cityId') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.contactInfo.state
                },
                (newValue) => {
                    // console.log('Key is fatcaInfo.CountryTax ')
                    // if (newValue == 'Sindh') {
                    this.filterCities(newValue)
                    // console.log(this.options)
                    // this.options =  this.filterCities(newValue)
                    // } else {
                    //    console.log(newValue)
                    // }
                }
            )
        } // End
        if (this.field.key == 'w9Info.cityId') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.w9Info.state
                },
                (newValue) => {
                    // console.log("new value ",newValue)
                    this.filterCities(newValue)
                }
            )
        } // End
        //CHECK RELIGION TO DISABLE/ENABLE ZAKAT OPTION

        if (this.field.key == 'basicInfo.zakatId') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.basicInfo
                        .religion
                },
                (newValue, oldValue) => {
                    // console.log("newvalue ", newValue)
                    if (newValue == 'Muslim') {
                        this.field.isRequired = true
                        this.field.isDisabled = false
                    } else {
                        this.field.isDisabled = true
                        this.field.isRequired = false
                        this.writeValue(null)
                    }
                }
            )
        }

        // Watching fatca Form for country tax
        if (this.field.key == 'fatcaInfo.CountryTax') {
            this.field.isDisabled = true
            this.field.isRequired = false
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.fatcaInfo
                        .CountryTaxOption
                },
                (newValue) => {
                    // console.log('Key is fatcaInfo.CountryTax ')
                    if (newValue == 'Yes') {
                        // console.log(newValue)
                        this.field.isDisabled = false
                        this.field.isRequired = true
                    } else {
                    this.$store.commit('updateField', {
                            key: 'fatcaInfo.CountryTaxTitle',
                            value: null,
                        })
                        this.value = null
                        this.model = null                        
                        this.writeValue(null)
                        this.field.isDisabled = true
                        this.field.isRequired = false
                    }
                }
            )
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> TIN 1
        if (this.field.key == 'crsInfo.crsReason1') {
            this.isDisabled = false
            // this.field.isRequired = false
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo.crsTIN1
                },
                (newValue) => {
                    // console.log('TIN 1 number ')
                    if (newValue.length != 0) {
                        // console.log(newValue)
                        this.isDisabled = true
                        this.field.isRequired = false
                        this.writeValue(null)
                    } else {
                        this.isDisabled = false
                        // this.field.isRequired = true
                    }
                }
            )
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> country of tax 1
        // if (this.field.key == 'crsInfo.crsReason1') {
        //     this.isDisabled = false
        //     // this.field.isRequired = false
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.crsInfo
        //                 .crsCountryTax1
        //         },
        //         (newValue) => {
        //             // console.log('TIN 1 number ')
        //             if (newValue.length != 0) {
        //                 // console.log(newValue)
        //                 this.isDisabled = false
        //                 this.field.isRequired = true
        //             } else {
        //                 // this.isDisabled = false
        //                 this.field.isRequired = false
        //             }
        //         }
        //     )
        // } // End

        // Watching CRS Form for Tax Residency Self Certification -> TIN 2
        if (this.field.key == 'crsInfo.crsReason2') {
            this.isDisabled = false
            // this.field.isRequired = false
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo.crsTIN2
                },
                (newValue) => {
                    // console.log('TIN 2 number ')
                    if (newValue.length != 0) {
                        // console.log(newValue)
                        this.isDisabled = true
                        this.field.isRequired = false
                        this.writeValue(null)
                    } else {
                        this.isDisabled = false
                        // this.field.isRequired = true
                    }
                }
            )
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> country of tax 2
        // if (this.field.key == 'crsInfo.crsReason2') {
        //     this.isDisabled = false
        //     // this.field.isRequired = false
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.crsInfo
        //                 .crsCountryTax2
        //         },
        //         (newValue) => {
        //             // console.log('TIN 1 number ')
        //             if (newValue.length != 0) {
        //                 // console.log(newValue)
        //                 this.isDisabled = false
        //                 this.field.isRequired = true
        //             } else {
        //                 // this.isDisabled = false
        //                 this.field.isRequired = false
        //             }
        //         }
        //     )
        // } // End

        // Watching CRS Form for Tax Residency Self Certification -> TIN 3
        if (this.field.key == 'crsInfo.crsReason3') {
            this.isDisabled = false
            // this.field.isRequired = false
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.crsInfo.crsTIN3
                },
                (newValue) => {
                    // console.log('TIN 3 number ')
                    if (newValue.length != 0) {
                        // console.log(newValue)
                        this.isDisabled = true
                        this.field.isRequired = false
                        this.writeValue(null)
                    } else {
                        this.isDisabled = false
                        // this.field.isRequired = true
                    }
                }
            )
        } // End

        // Watching CRS Form for Tax Residency Self Certification -> country of tax 3
        // if (this.field.key == 'crsInfo.crsReason3') {
        //     this.isDisabled = false
        //     // this.field.isRequired = false
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.crsInfo
        //                 .crsCountryTax3
        //         },
        //         (newValue) => {
        //             // console.log('TIN 1 number ')
        //             if (newValue.length != 0) {
        //                 // console.log(newValue)
        //                 this.isDisabled = false
        //                 this.field.isRequired = true
        //             } else {
        //                 // this.isDisabled = false
        //                 this.field.isRequired = false
        //             }
        //         }
        //     )
        // } // End
        // if (this.field.key == 'contactInfo.stateId' || this.field.key == 'contactInfo.city') {
        //     this.$store.watch(
        //         (state) => {
        //             return this.$store.state.registration.form.basicInfo.permPakResident
        //         },
        //         (newValue, oldValue) => {
        //             if (newValue == 'No') {
        //                 this.field.isRequired = false
        //                 this.isDisabled = true
        //             } else {
        //                 this.isDisabled = false
        //                 this.field.isRequired = true
        //             }
        //         }
        //     )
        // }

        if (this.field.key == 'contactInfo.cityId') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.contactInfo.state
                },
                (newValue, oldValue) => {
                    if (
                        newValue ==
                        '* Non-Pakistan (if not Resident in Pakistan)'
                    ) {
                        this.field.isRequired = false
                        this.field.isDisabled = true
                    } else {
                        this.field.isDisabled = false
                        this.field.isRequired = true
                    }
                }
            )
        }

        // RDA often uses list/relationPrinciple for nominee relation; TextField watcher does not run.
        const nomineeRelationKeys = [
            'accountInfo.nomineeRelationship1Id',
            //'accountInfo.nomineeRelationId1',
        ]
        if (nomineeRelationKeys.includes(this.field.key)) {
            const applyNomineeRelationRequired = (addNominee) => {
                if (addNominee === 'Yes') {
                    this.field.isRequired = true
                } else {
                    this.field.isRequired = false
                    this.writeValue(null)
                    this.$store.commit('updateField', {
                        key: 'accountInfo.nomineeRelationship1',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'regAccInfo.relationWithPrinciple',
                        value: null,
                    })
                }
            }
            applyNomineeRelationRequired(
                this.$store.state.registration.form.accountInfo.addNominee
            )
            this.$store.watch(
                (state) => state.registration.form.accountInfo.addNominee,
                applyNomineeRelationRequired
            )
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        handleBlur() {
            this.$root.$emit('updateTempCustomer')
        },
        /*
        |--------------------------------------------------------------------------
        | Manually setting the value of Dropdown
        |--------------------------------------------------------------------------
        */
        writeValue(newValue) {
            this.value = newValue
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: newValue,
                    },
                })
            }
        }, // End of Method > writeValue

        async filterCities(value) {
            let dataSegmentId = this.dataSegmentId
            if (dataSegmentId) {
                try {
                    let response = await axios.get(
                        apiUrl_data +
                            'configurations/citiesList/' +
                            dataSegmentId,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem(
                                    'vueauth_token'
                                )}`,
                            },
                        }
                    )
                    let data = response.data.data
                    // console.log(data)
                    for (let i = 0; i < data.length; i++) {
                        if (
                            data[i].title == value &&
                            data[i].dataSegmentId == dataSegmentId
                        ) {
                            this.cities = data[i].cities
                        }
                    }

                    let finalCities = this.cities.filter((city) => {
                        return city.dataSegmentId == dataSegmentId
                    })

                    this.options = finalCities
                    // console.log(this.options)
                    // .map((city) => {
                    //     return {
                    //         title: _.capitalize(city.title),
                    //         value: _.capitalize(city._id),
                    //     }
                    // })
                } catch (e) {
                    console.log('error: ', e)
                }
            }
        },
    },
}
</script>
